
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!./../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-be6b4b7c!stylus-loader!./../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Remark.vue")

var Component = require("!./../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Remark.vue"),
  /* template */
  require("!!./../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-be6b4b7c!./../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Remark.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/Main/Contact/Contact/Remark.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Remark.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-be6b4b7c", Component.options)
  } else {
    hotAPI.reload("data-v-be6b4b7c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Contact/Contact/Remark.vue
// module id = 791
// module chunks = 0